import { validateEnglishNumberUnderlineSpace, validateEnglishNumberUnderlineSpaceChinese } from '@/utils/validate.js'

/**
 * 验证优惠券名称：只能填字母、数字、空格、下划线
 *
 * @param {Object} rule 规则对象
 * @param {String} value 当前输入的值
 * @param {Function} callback 失败或成功的回调（失败则传入错误对象 成功则直接调用）
 */
export function validateCouponName(rule, value, callback) {
  if (value) {
    if (validateEnglishNumberUnderlineSpace(value)) {
      callback()
    } else {
      callback(new Error('优惠券名称只能填字母、数字、空格、下划线！'))
    }
  } else {
    callback(new Error('请输入优惠券名称！'))
  }
}

/**
 * 验证优惠券描述：只能填中文、字母、数字、空格、下划线
 *
 * @param {Object} rule 规则对象
 * @param {String} value 当前输入的值
 * @param {Function} callback 失败或成功的回调（失败则传入错误对象 成功则直接调用）
 */
export function validateCouponDescribe(rule, value, callback) {
  if (value) {
    if (validateEnglishNumberUnderlineSpaceChinese(value)) {
      callback()
    } else {
      callback(new Error('优惠券描述只能填中文、字母、数字、空格、下划线！'))
    }
  } else {
    callback()
  }
}
